(function () {
  'use strict';

  function initialiseComparison(root) {
    if (root.dataset.comparisonInitialised === 'true') return;

    var viewport = root.querySelector('[data-comparison-viewport]');
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-comparison-panel]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-comparison-group]'));
    var previousButton = root.querySelector('[data-comparison-previous]');
    var nextButton = root.querySelector('[data-comparison-next]');
    var startOutput = root.querySelector('[data-comparison-start]');
    var endOutput = root.querySelector('[data-comparison-end]');
    var rangeOutput = root.querySelector('[data-comparison-range]');
    var mobileQuery = window.matchMedia('(max-width: 899px)');
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var activeIndex = 0;
    var isTransitioning = false;
    var scrollFrame;
    var transitionTimer;

    if (!viewport || !panels.length || !groups.length) return;
    root.dataset.comparisonInitialised = 'true';
    root.classList.add('sano-comparison--carousel-ready');

    function visibleCount() {
      return 1;
    }

    function normalizeIndex(index) {
      var count = visibleCount();
      var maximum = Math.max(0, panels.length - count);
      var bounded = Math.max(0, Math.min(index, maximum));
      return count === 2 ? Math.floor(bounded / 2) * 2 : bounded;
    }

    function updateCounter(index) {
      activeIndex = normalizeIndex(index);
      var count = visibleCount();
      var end = Math.min(activeIndex + count, panels.length);
      if (startOutput) startOutput.textContent = activeIndex + 1;
      if (endOutput) endOutput.textContent = end;
      if (rangeOutput) rangeOutput.hidden = count === 1;
      if (previousButton) previousButton.disabled = activeIndex === 0;
      if (nextButton) nextButton.disabled = end === panels.length;
    }

    function showDesktopGroup(index, animate) {
      var groupIndex = normalizeIndex(index);
      var nextGroup = groups[groupIndex];
      var previousGroup = root.querySelector('[data-comparison-group].is-active');

      groups.forEach(function (group, currentIndex) {
        var isActive = currentIndex === groupIndex;
        group.classList.toggle('is-active', isActive);
        group.classList.toggle('is-transitioning-in', isActive && animate);
        group.classList.toggle('is-leaving', Boolean(animate && group === previousGroup && group !== nextGroup));
        group.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
      updateCounter(groupIndex);
    }

    function scrollMobileTo(index, behavior) {
      updateCounter(index);
      viewport.scrollTo({ left: panels[activeIndex].offsetLeft, top: 0, behavior: behavior });
    }

    function closestMobilePanelIndex() {
      var viewportLeft = viewport.getBoundingClientRect().left;
      var closestIndex = 0;
      var closestDistance = Infinity;
      panels.forEach(function (panel, index) {
        var distance = Math.abs(panel.getBoundingClientRect().left - viewportLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      return closestIndex;
    }

    function move(direction) {
      if (isTransitioning) return;
      var target = activeIndex + (direction * visibleCount());

      if (mobileQuery.matches) {
        isTransitioning = true;
        scrollMobileTo(target, prefersReducedMotion ? 'auto' : 'smooth');
        window.clearTimeout(transitionTimer);
        transitionTimer = window.setTimeout(function () { isTransitioning = false; }, 400);
        return;
      }

      var normalizedTarget = normalizeIndex(target);
      if (normalizedTarget === activeIndex) return;
      isTransitioning = true;
      showDesktopGroup(normalizedTarget, !prefersReducedMotion);
      window.clearTimeout(transitionTimer);
      transitionTimer = window.setTimeout(function () {
        groups.forEach(function (group) {
          group.classList.remove('is-leaving', 'is-transitioning-in');
        });
        isTransitioning = false;
      }, prefersReducedMotion ? 0 : 400);
    }

    viewport.addEventListener('scroll', function () {
      if (!mobileQuery.matches) return;
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(function () {
        updateCounter(closestMobilePanelIndex());
      });
    }, { passive: true });

    viewport.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      move(event.key === 'ArrowRight' ? 1 : -1);
    });

    if (previousButton) previousButton.addEventListener('click', function () { move(-1); });
    if (nextButton) nextButton.addEventListener('click', function () { move(1); });

    function handleBreakpointChange() {
      isTransitioning = false;
      window.clearTimeout(transitionTimer);

      if (mobileQuery.matches) {
        groups.forEach(function (group) {
          group.removeAttribute('aria-hidden');
          group.classList.remove('is-transitioning-in', 'is-leaving');
        });
        updateCounter(activeIndex);
        window.requestAnimationFrame(function () { scrollMobileTo(activeIndex, 'auto'); });
      } else {
        viewport.scrollLeft = 0;
        showDesktopGroup(activeIndex, false);
      }
    }

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', handleBreakpointChange);
    } else {
      mobileQuery.addListener(handleBreakpointChange);
    }

    handleBreakpointChange();

    // Read the existing preview button; never create or change a Shopify selection.
    var originalSet = root.querySelector('[data-comparison-original]');
    var blackFridaySet = root.querySelector('[data-comparison-black-friday]');
    var previewButton = document.querySelector('.sano-product-buybox [data-sano-mystery-preview]');
    var switchTimer;
    var previewObserver;
    var reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    function previewIsActive() {
      return previewButton && previewButton.getAttribute('aria-pressed') === 'true';
    }

    // Slider position is presentation state only; flavor truth remains the existing preview button.
    var bfSlides = blackFridaySet ? Array.prototype.slice.call(blackFridaySet.querySelectorAll('[data-bf-slide]')) : [];
    var bfDots = blackFridaySet ? Array.prototype.slice.call(blackFridaySet.querySelectorAll('[data-bf-dot]')) : [];
    var bfViewport = blackFridaySet && blackFridaySet.querySelector('[data-bf-viewport]');
    var bfPrevious = blackFridaySet && blackFridaySet.querySelector('[data-bf-previous]');
    var bfNext = blackFridaySet && blackFridaySet.querySelector('[data-bf-next]');
    var bfStatus = blackFridaySet && blackFridaySet.querySelector('[data-bf-status]');
    var bfCards=blackFridaySet?Array.from(blackFridaySet.querySelectorAll('.sano-comparison-bf__card:not(.sano-comparison-bf__card--ingredients)')):[];
    var bfPerPage=1;
    function regroupBlackFriday(){
      if(!bfCards.length)return;
      var currentPage=bfIndex;
      var track=blackFridaySet.querySelector('.sano-comparison-bf__track'),pagination=blackFridaySet.querySelector('.sano-comparison-bf__pagination');
      bfSlides=[];bfDots=[];track.replaceChildren();pagination.replaceChildren();
      for(var i=0;i<bfCards.length;i+=bfPerPage){
        var slide=document.createElement('div'),page=i/bfPerPage;slide.className='sano-comparison-bf__slide';slide.dataset.bfSlide=page;slide.id=root.id+'-comparison-page-'+page;slide.setAttribute('role','group');slide.setAttribute('aria-roledescription','slide');slide.setAttribute('aria-label','Vergelijking '+(i+1)+' van '+bfCards.length);
        bfCards.slice(i,i+bfPerPage).forEach(function(card){slide.appendChild(card);});track.appendChild(slide);bfSlides.push(slide);
        var dot=document.createElement('button');dot.type='button';dot.className='sano-comparison-bf__dot';dot.dataset.bfDot=page;dot.setAttribute('aria-label',slide.getAttribute('aria-label'));dot.setAttribute('aria-controls',slide.id);dot.innerHTML='<span aria-hidden="true"></span>';pagination.appendChild(dot);bfDots.push(dot);
      }
      bfGesture=null;bfTransitioning=false;showBlackFridaySlide(currentPage,false);
    }
    var bfIndex = 0;
    var bfTimer;
    var bfTransitioning = false;
    var bfGesture;
    var bfRevealTimer;
    var bfIgnoreClickUntil = 0;
    var bfGallery;

    function showBlackFridaySlide(index, animate) {
      if (!bfSlides.length || (animate && bfTransitioning)) return;
      index = Math.max(0, Math.min(index, bfSlides.length - 1));
      if (animate && index === bfIndex) return;
      var previous = bfIndex;
      var motion = animate && !reducedQuery.matches;
      window.clearTimeout(bfTimer);
      blackFridaySet.classList.toggle('is-moving', motion);
      blackFridaySet.querySelector('.sano-comparison-bf__track').style.setProperty('--bf-offset', (-index * 100) + '%');
      blackFridaySet.dataset.bfDirection = index < previous ? '-1' : '1';
      bfIndex = index;
      bfTransitioning = motion;
      bfSlides.forEach(function (slide, i) {
        var active = i === index;
        var leaving = motion && i === previous;
        slide.hidden = false;
        slide.inert = !active;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.classList.toggle('is-active', active);
        slide.classList.toggle('is-entering', active && motion);
        slide.classList.toggle('is-leaving', leaving);
      });
      bfDots.forEach(function (dot, i) {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      bfPrevious.disabled = index === 0;
      bfNext.disabled = index === bfSlides.length - 1;
      bfStatus.textContent = (index + 1) + ' / ' + bfSlides.length;
      if (motion) bfTimer = window.setTimeout(function () {
        bfSlides.forEach(function (slide, i) {
          // Offscreen pages remain in the track, inert and aria-hidden.
          slide.classList.remove('is-leaving');
        });
        bfTransitioning = false;
      }, mobileQuery.matches ? 320 : 620);
    }

    function resetBlackFridaySlider() {
      bfGesture = null;
      showBlackFridaySlide(0, false);
    }

    function openBFImage(button) {
      var pswp = document.querySelector('.pswp'), img = button.querySelector('img');
      if (!pswp || !window.PhotoSwipe || !window.PhotoSwipeUI_Default || pswp.classList.contains('pswp--open')) return;
      var close = pswp.querySelector('.pswp__button--close');
      var oldClose = close.innerHTML, oldLabel = close.getAttribute('aria-label');
      var oldDialogLabel = pswp.getAttribute('aria-label'), oldModal = pswp.getAttribute('aria-modal');
      var zoom = document.createElement('button');
      zoom.type = 'button'; zoom.className = 'sano-bf-lightbox__zoom'; zoom.textContent = 'Vergroten';
      pswp.querySelector('.pswp__top-bar').appendChild(zoom);
      close.innerHTML = '<span aria-hidden="true">×</span>'; close.setAttribute('aria-label', 'Vergroting sluiten');
      pswp.classList.add('sano-bf-lightbox'); pswp.setAttribute('aria-label', img.alt); pswp.setAttribute('aria-modal', 'true');
      bfGallery = new window.PhotoSwipe(pswp, window.PhotoSwipeUI_Default, [{src:img.currentSrc || img.src,w:Number(img.getAttribute('width')),h:Number(img.getAttribute('height')),title:img.alt}], {history:false,closeOnScroll:false,shareEl:false,fullscreenEl:false,arrowEl:false,showAnimationDuration:reducedQuery.matches?0:180,hideAnimationDuration:reducedQuery.matches?0:150});
      var gallery = bfGallery;
      var lastControlTap = 0;
      function controlEvent(event) {
        if (event.type === "pswpTap" && event.detail && event.detail.pointerType !== "touch") return false;
        if (event.type === "click" && performance.now() - lastControlTap < 350) return false;
        if (event.type === "pswpTap") lastControlTap = performance.now();
        event.preventDefault(); event.stopPropagation(); return true;
      }
      function closeImage(event) { if (controlEvent(event)) gallery.close(); }
      function zoomImage(event) {
        if (!controlEvent(event)) return;
        var scale = gallery.getZoomLevel(), fit = gallery.currItem.initialZoomLevel;
        var target = scale > fit + .02 ? fit : Math.max(1, fit * 2);
        gallery.zoomTo(target, {x:window.innerWidth / 2,y:window.innerHeight / 2}, reducedQuery.matches ? 0 : 180);
        zoom.textContent = target > fit + .02 ? 'Passend' : 'Vergroten';
      }
      function trapFocus(event) {
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); gallery.close(); return; }
        if (event.key !== 'Tab') return;
        var controls = [close, zoom], position = controls.indexOf(document.activeElement);
        event.preventDefault(); controls[(position + (event.shiftKey ? -1 : 1) + controls.length) % controls.length].focus();
      }
      close.addEventListener('click', closeImage); close.addEventListener('pswpTap', closeImage);
      zoom.addEventListener('pswpTap', zoomImage);
      zoom.addEventListener('click', zoomImage); pswp.addEventListener('keydown', trapFocus);
      gallery.listen('destroy', function () {
        close.removeEventListener('click', closeImage); close.removeEventListener('pswpTap', closeImage);
        zoom.remove(); pswp.removeEventListener('keydown', trapFocus); pswp.classList.remove('sano-bf-lightbox');
        Promise.resolve().then(function () { pswp.classList.remove('sano-bf-lightbox'); });
        close.innerHTML = oldClose;
        if (oldLabel === null) close.removeAttribute('aria-label'); else close.setAttribute('aria-label', oldLabel);
        if (oldDialogLabel === null) pswp.removeAttribute('aria-label'); else pswp.setAttribute('aria-label', oldDialogLabel);
        if (oldModal === null) pswp.removeAttribute('aria-modal'); else pswp.setAttribute('aria-modal', oldModal);
        bfGallery = null;
        if (button.isConnected && !blackFridaySet.hidden) button.focus({preventScroll:true});
      });
      gallery.init(); close.focus({preventScroll:true});
    }

    function bfClick(event) {
      var enlarge = event.target.closest("[data-bf-enlarge]");
      if (enlarge && blackFridaySet.contains(enlarge)) {
        if (!bfTransitioning && performance.now() >= bfIgnoreClickUntil) openBFImage(enlarge);
        return;
      }
      var dot = event.target.closest('[data-bf-dot]');
      if (dot && blackFridaySet.contains(dot)) showBlackFridaySlide(Number(dot.dataset.bfDot), true);
      else if (event.target.closest('[data-bf-previous]') === bfPrevious) showBlackFridaySlide(bfIndex - 1, true);
      else if (event.target.closest('[data-bf-next]') === bfNext) showBlackFridaySlide(bfIndex + 1, true);
    }

    function bfKeydown(event) {
      bfIgnoreClickUntil = 0;
      var index;
      if (event.key === 'ArrowLeft') index = bfIndex - 1;
      else if (event.key === 'ArrowRight') index = bfIndex + 1;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = bfSlides.length - 1;
      else return;
      event.preventDefault();
      showBlackFridaySlide(index, true);
    }

    function bfPointerDown(event) {
      if (!event.isPrimary || event.button !== 0 || bfTransitioning || blackFridaySet.hidden) return;
      bfIgnoreClickUntil = 0;
      bfGesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
      if (!event.target.closest("[data-bf-enlarge]")) bfViewport.setPointerCapture(event.pointerId);
    }

    function bfPointerUp(event) {
      if (!bfGesture || event.pointerId !== bfGesture.id) return;
      var dx = event.clientX - bfGesture.x, dy = event.clientY - bfGesture.y;
      bfGesture = null;
      if (Math.abs(dx) >= 44 && Math.abs(dx) > Math.abs(dy) * 1.25) {
        bfIgnoreClickUntil = performance.now() + 350;
        showBlackFridaySlide(bfIndex + (dx < 0 ? 1 : -1), true);
      }
    }

    function cancelBFGesture() { bfGesture = null; }

    function initialiseBlackFridaySlider() {
      if (!bfViewport || !bfSlides.length) return;
      regroupBlackFriday();
      blackFridaySet.addEventListener('click', bfClick);
      blackFridaySet.addEventListener('keydown', bfKeydown);
      bfViewport.addEventListener('pointerdown', bfPointerDown);
      bfViewport.addEventListener('pointerup', bfPointerUp);
      bfViewport.addEventListener('pointercancel', cancelBFGesture);
      bfViewport.addEventListener('lostpointercapture', cancelBFGesture);
      bfViewport.querySelectorAll('img').forEach(function (img) { img.draggable = false; });
    }

    function destroyBlackFridaySlider() {
      window.clearTimeout(bfTimer);
      window.clearTimeout(bfRevealTimer);
      if (bfGallery) bfGallery.close();
      if (!bfViewport) return;
      blackFridaySet.removeEventListener('click', bfClick);
      blackFridaySet.removeEventListener('keydown', bfKeydown);
      bfViewport.removeEventListener('pointerdown', bfPointerDown);
      bfViewport.removeEventListener('pointerup', bfPointerUp);
      bfViewport.removeEventListener('pointercancel', cancelBFGesture);
      bfViewport.removeEventListener('lostpointercapture', cancelBFGesture);
    }

    function revealBlackFriday() {
      if (!blackFridaySet || blackFridaySet.hidden || !previewIsActive()) return;
      if (blackFridaySet.classList.contains("is-revealed")) return;
      var sectionBox = bfViewport.getBoundingClientRect();
      var inView = sectionBox.bottom > 0 && sectionBox.top < window.innerHeight;
      {
        blackFridaySet.classList.add('is-revealed');
        window.clearTimeout(bfRevealTimer);
        if (reducedQuery.matches) blackFridaySet.classList.add('bf-intro-complete');
        else bfRevealTimer = window.setTimeout(function () { blackFridaySet.classList.add('bf-intro-complete'); }, 1000);
      }
    }

    function synchronizePreview(initial) {
      if (!originalSet || !blackFridaySet) return;
      var active = previewIsActive();
      // A repeated attribute assignment by the existing handler does not restart the reveal.
      if (active && (!blackFridaySet.hidden || (!initial && originalSet.classList.contains('is-preview-leaving')))) return;
      window.clearTimeout(switchTimer);
      originalSet.classList.remove('is-preview-leaving');
      if (!active) {
        window.clearTimeout(bfRevealTimer);
        if (bfGallery) bfGallery.close();
        blackFridaySet.classList.remove('bf-intro-complete');
        resetBlackFridaySlider();
        blackFridaySet.hidden = true;
        blackFridaySet.inert = true;
        blackFridaySet.setAttribute('aria-hidden', 'true');
        blackFridaySet.classList.remove('is-revealed');
        originalSet.hidden = false;
        originalSet.inert = false;
        originalSet.removeAttribute('aria-hidden');
        return;
      }
      originalSet.inert = true;
      originalSet.setAttribute('aria-hidden', 'true');
      function showBlackFriday() {
        if (!previewIsActive() || !root.isConnected) return;
        resetBlackFridaySlider();
        originalSet.hidden = true;
        originalSet.classList.remove('is-preview-leaving');
        blackFridaySet.hidden = false;
        blackFridaySet.inert = false;
        blackFridaySet.setAttribute('aria-hidden', 'false');
        revealBlackFriday();
      }
      if (initial || window.matchMedia('(prefers-reduced-motion: reduce)').matches) showBlackFriday();
      else {
        originalSet.classList.add('is-preview-leaving');
        switchTimer = window.setTimeout(showBlackFriday, 160);
      }
    }

    function initialisePreviewSwitch() {
      if (!previewButton || !blackFridaySet) return;
      initialiseBlackFridaySlider();
      synchronizePreview(true);
      previewObserver = new MutationObserver(function () { synchronizePreview(false); });
      previewObserver.observe(previewButton, { attributes: true, attributeFilter: ['aria-pressed'] });
      function restorePreview() { synchronizePreview(true); }
      window.addEventListener('pageshow', restorePreview);
      window.addEventListener('popstate', restorePreview);
      reducedQuery.addEventListener('change', revealBlackFriday);
      function unload(event) {
        if (event.target.contains(root)) {
            window.clearTimeout(transitionTimer);
            window.cancelAnimationFrame(scrollFrame);
            if (typeof mobileQuery.removeEventListener === 'function') mobileQuery.removeEventListener('change', handleBreakpointChange);
            else mobileQuery.removeListener(handleBreakpointChange);
            destroyBlackFridaySlider();
          previewObserver.disconnect();
          if (revealObserver) revealObserver.disconnect();
          window.clearTimeout(switchTimer);
          window.removeEventListener('pageshow', restorePreview);
          window.removeEventListener('popstate', restorePreview);
          reducedQuery.removeEventListener('change', revealBlackFriday);
          document.removeEventListener('shopify:section:unload', unload);
        }
      }
      document.addEventListener('shopify:section:unload', unload);
    }

    root.classList.add('is-revealed');
    var revealObserver, revealFallback;
    initialisePreviewSwitch();
  }

  function initialiseAll(container) {
    (container || document).querySelectorAll('[data-sano-comparison]').forEach(initialiseComparison);
  }

  document.addEventListener('DOMContentLoaded', function () { initialiseAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initialiseAll(event.target); });
})();
